// Channel icon + color now live in `channel-visuals.ts` (one source of truth).
// This file keeps only status-badge coloring.

export const getStatusColor = (status?: string) => {
  switch (status) {
    case "completed":
      return "bg-green-100 text-green-800";
    case "sent":
      return "bg-blue-100 text-blue-800";
    case "delivered":
      return "bg-green-100 text-green-800";
    case "read":
      return "bg-emerald-100 text-emerald-800";
    case "pending":
      return "bg-yellow-100 text-yellow-800";
    case "draft":
      return "bg-card-100 text-gray-800";
    case "accepted":
      return "bg-green-100 text-green-800";
    case "rejected":
      return "bg-red-100 text-red-800";
    case "scheduled":
      return "bg-purple-100 text-purple-800";
    case "cancelled":
      return "bg-red-100 text-red-800";
    case "internal":
      return "bg-yellow-100 text-yellow-800";
    case "public":
      return "bg-blue-100 text-blue-800";
    default:
      return "bg-card-100 text-gray-800";
  }
};
